<template>
<div class="preset-row">

  <div v-if="items && items.length">
    <div class="preset-buttons">
      <button
        v-for="preset in items"
        :key="preset"
        type="button"
        class="preset-btn"
        :class="{ 'is-selected': setAmountLocal == filter(preset) }"
        @click="selectAmount(preset)"
      >
        {{ currencySymbol }}{{ filter(preset) }}
      </button>
      <button
        v-if="showOther"
        type="button"
        class="preset-btn"
        :class="{ 'is-selected': otherAmountLocal && !setAmountLocal }"
        @click="selectAmount(null)"
      >
        {{ $vuetify.lang.t('$vuetify.common.custom') }}
      </button>
    </div>

    <div v-if="showOther" class="preset-custom-input">
      <spacer size="m" />
      <v-text-field
        :placeholder="$vuetify.lang.t('$vuetify.forms.deposit.enterCustomAmount')"
        type="number"
        step="1"
        :max="build.maxAmount"
        :min="build.minAmount || 0"
        v-model="otherAmountLocal"
        @input="handleInput"
        :error-messages="errors.otherAmount"
        hide-details="auto"
        filled
        rounded
        height="56"
        ref="customAmountInput"
      />
    </div>
  </div>

  <maskedInput
    v-else
    :label="$vuetify.lang.t('$vuetify.forms.amountPrompt')"
    icon="attach_money"
    v-model="otherAmountLocal"
    @input="handleInput"
    validation="nonempty"
    :errorMessages="errors['nameError']"
  />
</div>
</template>

<script>
import maskedInput from '../common/maskedInput'
import { mapGetters } from 'vuex';
import Spacer from '../common/Spacer';
export default {
  components: {
    maskedInput,
    Spacer,
  },

  props: {
    items: {
      type: Array,
      required: true
    },

    setAmount: { },
    otherAmount: { },
    amount: {
      default: function () {
        return this.setAmount || this.otherAmount
      }
    },

    filter: {
      type: Function,
      default: (val) => val
    },

    showOther: {
        type: Boolean,
        default: false
    }
  },

  data() {
      return {
        setAmountLocal: this.setAmount,
        otherAmountLocal: this.otherAmount,
        errors: this.$parent?.errors || this.$parent?.$parent?.errors
      }
  },

  computed: {
    ...mapGetters({
			build: 'getBuild',
      currencySymbol: 'getCurrenySymbol',
		})
  },

  methods: {
    currency(val, showDec = false) { return this.$options.filters.currency(val, showDec) },

    emitUp() {
      this.$emit('update:setAmount', this.setAmountLocal)
      this.$emit('update:otherAmount', this.otherAmountLocal)
      this.$emit('update:amount', this.setAmountLocal || this.otherAmountLocal)
    },
    selectAmount(preset) {
      if (preset === null) {
        this.setAmountLocal = null
        this.$nextTick(this.focusCustomInput)
      } else {
        this.setAmountLocal = this.filter(preset)
        this.otherAmountLocal = null
      }

      this.emitUp()
      this.validate()
    },
    handleInput($event) {
      this.otherAmountLocal = $event
      this.setAmountLocal = null

      this.emitUp()
      this.validate()
    },

    focusCustomInput() {
      const input = this.$refs.customAmountInput?.$el?.querySelector('input')
      if (input) input.focus()
    },

    applyDefaults() {
      if (this.items?.length) {
        // If a default amount was provived, match it to a preset or the otherAmount
        if (this.amount != null) {
          const matchPreset = this.items.findIndex(preset => this.filter(preset) === this.amount)

          if (matchPreset >= 0) {
            this.selectAmount(this.items[matchPreset])
          } else {
            this.otherAmountLocal = this.amount
          }
        } else {
          // Otherwise, use the first preset as default
          this.selectAmount(this.items[0])
        }
      }
    },

    validate() {
      // Assume set amounts are valid since users can't enter anything that wouldn't be
      if (!this.setAmountLocal) {
        if (this.otherAmountLocal === null || this.otherAmountLocal === undefined || this.otherAmountLocal === '')
          this.$set(this.errors, 'otherAmount', this.$vuetify.lang.t('$vuetify.forms.cardPrompt'))
        else if (this.otherAmountLocal > this.build.maxAmount)
          this.$set(this.errors, 'otherAmount', this.$vuetify.lang.t('$vuetify.forms.amountMax', this.currency(this.build.maxAmount)))
        else if (this.otherAmountLocal < (this.build.minAmount || 0.01))
          this.$set(this.errors, 'otherAmount', this.$vuetify.lang.t('$vuetify.forms.amountMin', this.currency(this.build.minAmount || 0.01)))
        else
          this.$delete(this.errors, 'otherAmount')
      } else {
        this.$delete(this.errors, 'otherAmount')
      }
    }
  },

  mounted() {
    this.applyDefaults()
  },
}
</script>

<style scoped>
.preset-row {
  width: 100%;
}

.preset-title {
  font-size: 18px;
  font-weight: 700;
  padding: 16px 16px 0 !important;
}

.preset-buttons {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.preset-btn {
  flex: 1;
  min-width: 80px;
  border: none;
  border-radius: 16px;
  height: 64px;
  line-height: 64px;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  background: #f3f4f6;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
}

.preset-btn:hover {
  background: #e5e7eb;
}

.preset-btn.is-selected {
  background: var(--primary-color, #16a34a);
  color: #ffffff;
}

.preset-custom-input {
  margin-top: 12px;
}

.preset-custom-input .v-input__control .v-input__slot {
  background: #f3f4f6 !important;
  border-radius: 12px;
}

.preset-custom-input input::placeholder {
  color: #9ca3af !important;
}
</style>
